import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";

class EventsidebarController {
  constructor($http, $state, $stateParams, AuthService, EventsService, SecurityService, $rootScope, $scope, $timeout, $location) {
    this.name = "eventsidebar";
    this.$http = $http;
    this.$auth = AuthService;
    this.$scope = $scope;
    this.$state = $state;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$events = EventsService;
    this.$security = SecurityService;
    this.currentUser = this.$auth.getUserData();
    this.$rootScope = $rootScope;
    this.isTheEventOpen = true;
    this.event = {};
    this.eventId = this.$stateParams.eventId;

    var _this = this;

    _this.SetEventToEventSidebarListener = _this.$rootScope.$on("SetEventToEventSidebar", function ($event, params) {
      _this.event = params.event;

      console.log("params");
      console.dir(params);

      if (_this.event.isClosed === true || _this.event.isCancelled === true || _this.event.isCompleted === true) {
        _this.isTheEventOpen = false;
        _this.isReadyToShow = true;
      } else {
        _this.isTheEventOpen = true;
        _this.isReadyToShow = true;
      }
    });

    console.log("check current user sidebar");
    console.dir(_this.currentUser);
    _this.checkAdmin();
    _this.$scope.$on("$destroy", _this.SetEventToEventSidebarListener);
  }

  setEvent() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventToEventDialog", {
        event: _this.event,
      });
    });
  }

  checkAdmin() {
    var _this = this;

    if (_this.currentUser) {
      _this.admin = _this.$auth.isAdmin();

      console.log("what is this admin");
      console.dir(_this.admin);
    }
  }

  inboxLink() {
    var _this = this;
    if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
      alert("This account has no active messages. If you think there are active messages please refresh the page.");
    } else {
      _this.$timeout(function () {
        //_this.$state.go('inbox');
        _this.$location.path("/messages/event/" + _this.event.id);
      });
    }
  }
}

EventsidebarController.$inject = ["$http", "$state", "$stateParams", "auth", "events", "security", "$rootScope", "$scope", "$timeout", "$location"];

export default EventsidebarController;



// WEBPACK FOOTER //
// ./client/app/common/eventsidebar/eventsidebar.controller.js